import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export const useI18nUrls = () => {
  const { i18n } = useTranslation()
  const [termsUrl, setTermsUrl] = useState<string>('https://raund.net/terms/?no_layout=true')
  const [faqUrl, setFaqUrl] = useState<string>('https://raund.net/user_qa/')
  const [faqArCameraUrl, setFaqArCameraUrl] = useState<string>('https://raund.net/user_qa/ar_camera/')
  const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState<string>('https://raund.net/privacy/')

  const updateUrls = () => {
    if (i18n.language === 'ja_JP') {
      setTermsUrl('https://raund.net/terms/?no_layout=true')
      setFaqUrl('https://raund.net/user_qa/?no_layout=true')
      setFaqArCameraUrl('https://raund.net/user_qa/ar_camera/')
      setPrivacyPolicyUrl('https://raund.net/privacy/?no_layout=true')
    } else if (
      i18n.language === 'en_US' ||
      i18n.language === 'ko_KR' ||
      i18n.language === 'zh_CH' ||
      i18n.language === 'zh_TW'
    ) {
      setTermsUrl('https://raund.net/en/terms-en/')
      setFaqUrl('https://raund.net/en/user_qa/')
      setFaqArCameraUrl('https://raund.net/en/user_qa/ar-camera/')
      setPrivacyPolicyUrl('https://raund.net/en/privacy-en/')
    } else {
      // 言語設定が取得できない場合のfallbackとして機能
      setTermsUrl('https://raund.net/terms/?no_layout=true')
      setFaqUrl('https://raund.net/user_qa/?no_layout=true')
      setFaqArCameraUrl('https://raund.net/user_qa/ar_camera/')
      setPrivacyPolicyUrl('https://raund.net/privacy/?no_layout=true')
    }
  }
  useEffect(() => {
    updateUrls()
  }, [i18n.resolvedLanguage])
  return { termsUrl, faqUrl, faqArCameraUrl, privacyPolicyUrl }
}
